import React, { useEffect, useRef, useState } from "react";
import { usePromoCodeStore } from "../../../store/promoCodeStore.js";

import moment from "moment";
import {
  Table,
  ConfigProvider,
  Input,
  Select,
  Modal,
  message,
  DatePicker,
  Popconfirm,
} from "antd";
import dayjs from "dayjs";


import images from "../../../assets";
import {
  VioletButtonLarge,
  WhiteButton,
  PrimaryButton,
} from "../../../components/button";
import Spacer from "../../../components/spacer/spacer";

const PromoCodes = () => {
  const {
    promoCodes,
    isLoading,
    getPromoCodes,
    addPromoCode,
    updatePromoCode,
    deletePromoCode,
  } = usePromoCodeStore();
  const tableRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [modalData, setmodalData] = useState(null);

  console.log(modalData);
  useEffect(() => {
    fetchPromoCodes();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [promoCodes, searchText, statusFilter]);

  const fetchPromoCodes = async () => {
    getPromoCodes({});
  };

  const applyFilters = () => {
    let filtered = promoCodes;

    if (searchText) {
      filtered = filtered?.filter((item) =>
        item?.name?.toLowerCase().includes(searchText?.toLowerCase())
      );
    }

    if (statusFilter) {
      filtered = filtered?.filter((item) => item?.status === statusFilter);
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleStatusChange = (value) => {
    setStatusFilter(value);
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);

    if (tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleAdd = () => {
    if (
      !modalData?.name ||
      !modalData?.discountPercentage ||
      !modalData?.maxUsage ||
      !modalData?.status ||
      !modalData?.expiryDate
    ) {
      message.error("Please fill all the required fields");
      return;
    } else {
      const payload = modalData;
      addPromoCode(payload, () => {
        getPromoCodes({});
        setAddModalOpen(false);
        setmodalData(null);
      });
    }
  };
  const handleUpdate = () => {
    if (
      !modalData?.name ||
      !modalData?.discountPercentage ||
      !modalData?.maxUsage ||
      !modalData?.status ||
      !modalData?.expiryDate
    ) {
      message.error("Please fill all the required fields");
      return;
    } else {
      const payload = { id: modalData?.id, data: modalData };

      updatePromoCode(payload, () => {
        getPromoCodes({});
        setEditModalOpen(false);
        setmodalData(null);
      });
    }
  };

  const handleDelete = (id) => {
    deletePromoCode({ id }, () => {
      getPromoCodes({});
    });
  };

  const columns = [
    {
      title: "Promo Code",
      width: 120,
      render: (text, record) => record?.name,
      key: "2",
    },
    {
      title: "Amount (Percentage)",
      key: "3",
      width: 130,
      render: (text, record) => record?.discountPercentage,
      fixed: "left",
    },
    {
      title: "Max Usage",
      key: "11",
      width: 130,
      render: (text, record) => record?.maxUsage,
      fixed: "left",
    },
    {
      title: "Status",
      key: "4",
      render: (text, record) => record?.status,
      width: 150,
    },
    {
      title: "Expiry Date",
      key: "10",
      render: (text, record) => moment(record?.expiryDate).format("DD.MM.YYYY"),
      width: 130,
    },
    {
      title: "Created At",
      key: "13",
      render: (text, record) => moment(record?.createdAt).format("DD.MM.YYYY"),
      width: 130,
    },
    {
      title: "Updated At",
      key: "15",
      render: (text, record) => moment(record?.updatedAt).format("DD.MM.YYYY"),
      width: 130,
    },
    {
      title: "Action",
      key: "17",
      fixed: "right",
      align: "center",
      width: 80,
      render: (text, record) => (
        <div className="flex gap-2 flex-wrap">
          <img
            src={images.editIcon}
            alt=""
            onClick={() => {
              setmodalData(record);
              setEditModalOpen(record);
            }}
          />
          <Popconfirm
            title="Delete promo?"
            description="Are you sure you want to delete this promo?"
            onConfirm={() => handleDelete(record?.id)}
            okText="Yes"
            cancelText="No"
            placement="left"
          >
            <img src={images.deleteIcon} alt="" />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div className="w-full p-4 text-black">
      <div ref={tableRef}></div>
      <div className="mb-4 grid grid-cols-4 gap-5 items-end">
        <div className="flex flex-col gap-2 w-full">
          <div>Search</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Keywords"
            onChange={(e) => handleSearch(e.target.value)}
            value={searchText}
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <div>Status</div>
          <Select
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Filter by Status"
            onChange={handleStatusChange}
            allowClear
            options={[
              { label: "Active", value: "active" },
              { label: "Inactive", value: "inactive" },
            ]}
            value={statusFilter}
          />
        </div>

        <VioletButtonLarge
          text="Add Promo Code"
          onClick={() => setAddModalOpen(true)}
        />
      </div>
      <div>
        Total: <strong>{filteredData?.length}</strong>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#310048",
              headerColor: "#ffffff",
              cellFontSize: "14px",
              headerSortHoverBg: "#310048",
              headerSortActiveBg: "",
            },
          },
        }}
      >
        <Table
          className="user-list"
          bordered
          columns={columns}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            pageSizeOptions: ["50", "100", "500", "1000"],
            showSizeChanger: true,
            total: filteredData.length,
          }}
          dataSource={filteredData}
          scroll={{
            x: 1500,
            y: 600,
          }}
          loading={isLoading}
          rowKey={(record) => record?.username}
          onChange={handleTableChange}
        />
      </ConfigProvider>
      <Modal
        centered={true}
        open={editModalOpen}
        onCancel={() => {
          setmodalData(null);
          setEditModalOpen(false);
        }}
        footer={false}
        closable={true}
      >
        <div className="text-[26px] font-bold text-basePrimary text-center">
          Add Promo Code
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <div>Promo Code *</div>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Promo code"
              onChange={(e) =>
                setmodalData({ ...modalData, name: e.target.value })
              }
              value={modalData?.name}
            />
          </div>
          <div className="flex flex-col gap-2">
            <div>Discount Percentage *</div>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="disount"
              onChange={(e) =>
                setmodalData({
                  ...modalData,
                  discountPercentage: e.target.value,
                })
              }
              value={modalData?.discountPercentage}
              type="number"
            />
          </div>
          <div className="flex flex-col gap-2">
            <div>Max Usage *</div>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="max usage"
              onChange={(e) =>
                setmodalData({ ...modalData, maxUsage: e.target.value })
              }
              value={modalData?.maxUsage}
              type="number"
            />
          </div>
          <div className="flex flex-col gap-2">
            <div>Status *</div>

            <Select
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Select status"
              options={[
                {
                  label: "Active",
                  value: "active",
                },
                {
                  label: "Inactive",
                  value: "inactive",
                },
              ]}
              value={modalData?.status}
              onChange={(e) => setmodalData({ ...modalData, status: e })}
            />
          </div>
          <div className="flex flex-col gap-2">
            <div>Expires At *</div>
            <DatePicker
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Date Published"
              onChange={(date, dateString) => {
                setmodalData({
                  ...modalData,
                  expiryDate: dateString,
                });
              }}
              value={
                modalData?.expiryDate
                  ? dayjs(modalData?.expiryDate, "YYYY-MM-DD")
                  : null
              }
            />
          </div>
        </div>
        <Spacer height="16px" />
        <div className="flex w-full justify-end">
          <div className="flex gap-4 set-profile-photo-btn">
            <PrimaryButton
              text="Update"
              style={{ background: "#F31260" }}
              onClick={handleUpdate}
            />
            <WhiteButton
              text="Cancel"
              onClick={() => {
                setmodalData(null);
                setAddModalOpen(false);
              }}
            />
          </div>
        </div>
      </Modal>
      <Modal
        centered={true}
        open={addModalOpen}
        onCancel={() => {
          setmodalData(null);
          setAddModalOpen(false);
        }}
        footer={false}
        closable={true}
      >
        <div className="text-[26px] font-bold text-basePrimary text-center">
          Add Promo Code
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <div>Promo Code *</div>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Promo code"
              onChange={(e) =>
                setmodalData({ ...modalData, name: e.target.value })
              }
              value={modalData?.name}
            />
          </div>
          <div className="flex flex-col gap-2">
            <div>Discount Percentage *</div>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="disount"
              onChange={(e) =>
                setmodalData({
                  ...modalData,
                  discountPercentage: e.target.value,
                })
              }
              value={modalData?.discountPercentage}
              type="number"
            />
          </div>
          <div className="flex flex-col gap-2">
            <div>Max Usage *</div>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="max usage"
              onChange={(e) =>
                setmodalData({ ...modalData, maxUsage: e.target.value })
              }
              value={modalData?.maxUsage}
              type="number"
            />
          </div>
          <div className="flex flex-col gap-2">
            <div>Status *</div>

            <Select
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Select status"
              options={[
                {
                  label: "Active",
                  value: "active",
                },
                {
                  label: "Inactive",
                  value: "inactive",
                },
              ]}
              value={modalData?.status}
              onChange={(e) => setmodalData({ ...modalData, status: e })}
            />
          </div>
          <div className="flex flex-col gap-2">
            <div>Expires At *</div>
            <DatePicker
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Date Published"
              onChange={(date, dateString) => {
                setmodalData({
                  ...modalData,
                  expiryDate: dateString,
                });
              }}
              value={
                modalData?.expiryDate
                  ? dayjs(modalData?.expiryDate, "YYYY-MM-DD")
                  : null
              }
            />
          </div>
        </div>
        <Spacer height="16px" />
        <div className="flex w-full justify-end">
          <div className="flex gap-4 set-profile-photo-btn">
            <PrimaryButton
              text="Add Promo"
              style={{ background: "#F31260" }}
              onClick={handleAdd}
            />
            <WhiteButton
              text="Cancel"
              onClick={() => {
                setmodalData(null);
                setAddModalOpen(false);
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PromoCodes;








